import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-beaker",
  "use": "icon-beaker-usage",
  "viewBox": "70.3 74.5 154.3 166",
  "content": "<symbol viewBox=\"70.3 74.5 154.3 166\" id=\"icon-beaker\">\r\n<path d=\"M219.5,204.9l-51.3-85.4V84.9h5.2c2.9,0,5.2-2.3,5.2-5.2s-2.3-5.2-5.2-5.2h-51.9c-2.9,0-5.2,2.3-5.2,5.2s2.3,5.2,5.2,5.2\r\n\th5.2v34.6l-51.3,85.4c-11.7,19.6-2.7,35.6,20.1,35.6h103.8C222.2,240.5,231.3,224.5,219.5,204.9z M103.6,178.3l33.6-55.9V84.9h20.8\r\n\tv37.5l33.6,55.9H103.6z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./app/general/svg/beaker.svg
// module id = wMjV
// module chunks = 0